/* tslint:disable */
/* eslint-disable */
/* @relayHash 7ab371858c07a27e94326d61415c777b */

import { ConcreteRequest } from "relay-runtime";
export type UpdateUserBadgesOnSiteInput = {
    clientMutationId: string;
    userID: string;
    siteID: string;
    badges: Array<BadgeRuleInput>;
};
export type BadgeRuleInput = {
    badge: string;
    startDate?: string | null;
    endDate?: string | null;
    isUserSpecific?: boolean | null;
};
export type UpdateUserBadgesMutationVariables = {
    input: UpdateUserBadgesOnSiteInput;
};
export type UpdateUserBadgesMutationResponse = {
    readonly updateUserBadgesOnSite: {
        readonly modifiedCount: number;
        readonly matchedCount: number;
        readonly clientMutationId: string;
    };
};
export type UpdateUserBadgesMutation = {
    readonly response: UpdateUserBadgesMutationResponse;
    readonly variables: UpdateUserBadgesMutationVariables;
};



/*
mutation UpdateUserBadgesMutation(
  $input: UpdateUserBadgesOnSiteInput!
) {
  updateUserBadgesOnSite(input: $input) {
    modifiedCount
    matchedCount
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpdateUserBadgesOnSitePayload",
            "kind": "LinkedField",
            "name": "updateUserBadgesOnSite",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modifiedCount",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "matchedCount",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateUserBadgesMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateUserBadgesMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "7ab371858c07a27e94326d61415c777b",
            "metadata": {},
            "name": "UpdateUserBadgesMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '042dd9a154f055bdc00602d5fd478b40';
export default node;
